<template>
  <b-modal
    centered
    id="modal-queries"
    footer-class="removed"
    cancel-variant="outline-secondary"
    title="سجل التقارير المحفوظة"
    v-model="isModalOpen"
    size="lg"
    static
  >
    <b-tabs>
      <b-tab key="1" title="المحفوظة">
        <data-table
          hover
          bordered
          :fields="savedFields"
          ep="v2/ministry/report-histories?tracking=true"
          @row-clicked="$emit('querySelected', $event)"
        >
          <template #cell(updated_at)="{ item }">
            <span dir="ltr">
              {{ formatDate(item.updated_at, 'YYYY-MM-DD h:mm A') }}
            </span>
          </template>
        </data-table>
      </b-tab>
      <b-tab key="2" title="الغير محفوظة">
        <data-table
          hover
          bordered
          small
          :fields="unsavedFields"
          ep="v2/ministry/report-histories?tracking=false"
          @row-clicked="$emit('querySelected', $event)"
        >
          <template #cell(created_at)="{ item }">
            <span dir="ltr">
              {{ formatDate(item.created_at, 'YYYY-MM-DD h:mm A') }}
            </span>
          </template>
        </data-table>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { BModal, BCard, BTabs, BTab } from "bootstrap-vue";
import DataTable from "@/components/data-table";
import { formatDate } from "@/utils/utils";
export default {
  components: {
    BModal,
    BCard,
    BTabs,
    BTab,
    DataTable,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      savedFields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "name",
          label: "الاسم",
        },
        {
          key: "updated_at",
          label: "تاريخ الحفظ",
        },
      ],
      unsavedFields: [
        {
          key: "id",
          label: "المعرف",
        },

        {
          key: "created_at",
          label: "تاريخ الإنشاء",
        },
      ],
    };
  },
  methods: {
     
    formatDate(value , formFormat) {
      return formatDate(value, formFormat);
    },
  },
  computed: {
    isModalOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
